/**
 * Avalia força da senha (cliente). Níveis: weak | medium | strong.
 * Alinhado ao backend: mínimo 6 caracteres (@Size em UpdatePasswordRequest).
 */
export function evaluatePasswordStrength(password) {
  const p = (typeof password === 'string' ? password : '').trim()
  if (!p.length) {
    return {
      level: 'empty',
      score: 0,
      segments: 0,
      labelKey: '',
      minLengthOk: false
    }
  }

  let score = 0
  if (p.length >= 6) score++
  if (p.length >= 10) score++
  if (/[a-z]/.test(p)) score++
  if (/[A-Z]/.test(p)) score++
  if (/\d/.test(p)) score++
  if (/[^A-Za-z0-9]/.test(p)) score++

  const minLengthOk = p.length >= 6

  let level
  let labelKey
  let segments

  if (!minLengthOk) {
    level = 'weak'
    labelKey = 'password.strength.tooShort'
    segments = 1
  } else if (score <= 3) {
    level = 'weak'
    labelKey = 'password.strength.weak'
    segments = 1
  } else if (score <= 5) {
    level = 'medium'
    labelKey = 'password.strength.medium'
    segments = 2
  } else {
    level = 'strong'
    labelKey = 'password.strength.strong'
    segments = 3
  }

  return {
    level,
    score,
    segments,
    labelKey,
    minLengthOk
  }
}

export function passwordRulesStatus(password) {
  const p = (typeof password === 'string' ? password : '').trim()
  return {
    min6: p.length >= 6,
    hasLower: /[a-z]/.test(p),
    hasUpper: /[A-Z]/.test(p),
    hasDigit: /\d/.test(p),
    hasSpecial: /[^A-Za-z0-9]/.test(p),
    length10: p.length >= 10
  }
}
